import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    IconButton, CircularProgress, Modal, Button
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
// 👇 PERCORSO CORRETTO 👇
import GenericForm from '../components/GenericForm.js';
import { businessFormFields } from '../forms/businessFormFields.js';

const AdminBusinesses = () => {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [editingBusiness, setEditingBusiness] = useState(null);
  const [formData, setFormData] = useState({});
  const [allCategories, setAllCategories] = useState([]);

  const style = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 500, bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2,
    maxHeight: '90vh', overflowY: 'auto'
  };

  const fetchBusinesses = () => {
    setLoading(true);
    axios.get('/api/admin/businesses')
      .then(res => setBusinesses(res.data))
      .catch(err => console.error("Errore nel caricare le aziende:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => { 
    fetchBusinesses(); 
    // Carica le categorie disponibili per l'autocomplete
    axios.get('/api/categories')
      .then(res => setAllCategories(res.data))
      .catch(err => console.error("Errore nel caricare le categorie:", err));
  }, []);

  const handleDelete = (businessId) => {
    if (window.confirm('Sei sicuro di voler eliminare questa azienda?')) {
      axios.delete(`/api/admin/businesses/${businessId}`).then(() => fetchBusinesses());
    }
  };

  const handleViewDetails = (businessId) => {
    axios.get(`/api/admin/business-details/${businessId}`).then(res => setSelectedBusiness(res.data));
  };

  const handleOpenEditModal = (bizToEdit) => {
    axios.get(`/api/admin/business-details/${bizToEdit.id}`).then(res => {
      setFormData(res.data);
      setEditingBusiness(res.data);
    });
  };

  const handleCloseEditModal = () => {
    setEditingBusiness(null);
    setFormData({});
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    axios.put(`/api/admin/businesses/${editingBusiness.id}`, formData)
      .then(() => {
        handleCloseEditModal();
        fetchBusinesses();
      })
      .catch(err => alert('Errore durante l\'aggiornamento.'));
  };

  if (loading) return <CircularProgress />;

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Gestione Aziende Partner</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome Azienda</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Stato</TableCell>
              <TableCell align="right">Azioni</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {businesses.map((biz) => (
              <TableRow key={biz.id}>
                <TableCell>{biz.name}</TableCell>
                <TableCell>{biz.email}</TableCell>
                <TableCell>{biz.status}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => handleViewDetails(biz.id)} title="Vedi Dettagli"><VisibilityIcon /></IconButton>
                  <IconButton onClick={() => handleOpenEditModal(biz)} color="primary" title="Modifica"><EditIcon /></IconButton>
                  <IconButton onClick={() => handleDelete(biz.id)} color="error" title="Elimina"><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal open={!!selectedBusiness} onClose={() => setSelectedBusiness(null)}>
        <Box sx={style}>
          {selectedBusiness && <>
            <Typography variant="h6">Dettagli Azienda</Typography>
            <Typography sx={{ mt: 2 }}><b>Azienda:</b> {selectedBusiness.name}</Typography>
            <Typography><b>Email:</b> {selectedBusiness.email}</Typography>
            <Typography><b>Contatto:</b> {selectedBusiness.contactPerson}</Typography>
            <Typography><b>Telefono:</b> {selectedBusiness.phone}</Typography>
            <Typography><b>Indirizzo:</b> {selectedBusiness.address}</Typography>
            <Typography><b>Provincia:</b> {selectedBusiness.province}</Typography>
            <Typography><b>Settore:</b> {selectedBusiness.sector}</Typography>
            <Typography><b>Descrizione:</b> {selectedBusiness.description}</Typography>
          </>}
        </Box>
      </Modal>

      <Modal open={!!editingBusiness} onClose={handleCloseEditModal}>
        <Box sx={style}>
          <Typography variant="h6">Modifica Azienda</Typography>
          <Box component="form" onSubmit={handleUpdate} sx={{ mt: 2 }}>
              <GenericForm
                fields={businessFormFields}
                formData={formData}
                setFormData={setFormData}
                availableSkills={allCategories}
              />
              <Button type="submit" variant="contained" sx={{ mt: 3 }}>Salva Modifiche</Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AdminBusinesses;